const isDev = import.meta.env.DEV;

type LogArgs = Parameters<typeof console.log>;

export const devLogger = {
  log: (...args: LogArgs) => {
    if (isDev) {
      console.log(...args);
    }
  },
  warn: (...args: LogArgs) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  error: (...args: LogArgs) => {
    if (isDev) {
      console.error(...args);
    }
  },
};
